import { Provider } from 'mobx-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ContactFloater } from './ContactFloater';

export default function KontaktFloaterApp() {
	return (
		<Router>
			<Provider authenticationService={{ isAuthenticated: () => false }}>
				<ContactFloater />
			</Provider>
		</Router>
	);
}
